var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterfaceArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9753 13.6668C16.9753 14.5874 17.1042 15.8834 17.2373 16.9754C17.3729 18.0883 18.4864 18.8011 19.5127 18.3499C21.3916 17.5239 23.1233 16.2986 24.3353 14.5167C24.6844 14.0034 24.6844 13.3302 24.3353 12.8169C23.1234 11.0349 21.3917 9.80963 19.5128 8.98368C18.4865 8.53251 17.373 9.2453 17.2374 10.3582C17.1043 11.4502 16.9753 12.7462 16.9753 13.6668Z",
    fill: "#84C70D",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9753 13.6668C16.9753 14.5874 17.1042 15.8834 17.2373 16.9754C17.3729 18.0883 18.4864 18.8011 19.5127 18.3499C21.3916 17.5239 23.1233 16.2986 24.3353 14.5167C24.6844 14.0034 24.6844 13.3302 24.3353 12.8169C23.1234 11.0349 21.3917 9.80963 19.5128 8.98368C18.4865 8.53251 17.373 9.2453 17.2374 10.3582C17.1043 11.4502 16.9753 12.7462 16.9753 13.6668Z",
    stroke: "#84C70D",
    strokeWidth: 2.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43655 13.668L16.9766 13.668",
    stroke: "#84C70D",
    strokeWidth: 2.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceArrowRight);
export default __webpack_public_path__ + "static/media/interface-arrow-right.733f7b7f8ca29f8e00dade0bc4a06da2.svg";
export { ForwardRef as ReactComponent };